/**
 * MONTHLY GIVING — the only file you need to edit each month.
 *
 * To feature a new cause:
 *   1. Add a new entry to the TOP of MONTHLY_HIGHLIGHTS (newest first).
 *   2. That's it — the page automatically features the first entry and
 *      moves everything below it into "Where we've given".
 */

export type MonthlyHighlight = {
  /** e.g. 'August 2026' — shown as the badge on the page */
  month: string
  /** Organisation name */
  name: string
  /** One-line summary shown under the name */
  tagline: string
  /** Two short paragraphs telling their story */
  paragraphs: string[]
  /** Where they are based */
  location: string
  /** Their website */
  url: string
  /** Optional direct donate link — falls back to the website */
  donateUrl?: string
  /** Full image URL used on the feature card */
  image: string
  /** Alt text for that image */
  imageAlt: string
}

export const MONTHLY_HIGHLIGHTS: MonthlyHighlight[] = [
  {
    month: 'August 2026',
    name: 'The Gentle Barn',
    tagline: 'A sanctuary for animals rescued from slaughterhouses and dairy farms.',
    paragraphs: [
      'The Gentle Barn rescues animals who have known the worst of us: cows, horses, pigs, goats and turkeys pulled from slaughterhouses, dairy farms and neglect. It gives them somewhere soft to land. Every animal there is rehabilitated slowly, on their own timeline, and then allowed to simply live.',
      'What moves us most is what happens next: those same animals help people heal too. Their story is the one we keep coming back to at PARṆA, that tenderness toward the living world and tenderness toward ourselves are the same practice.',
    ],
    location: 'Santa Clarita, California',
    url: 'https://www.gentlebarn.org',
    donateUrl: 'https://www.gentlebarn.org',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/1e91e16f-a345-4e60-9cde-61136591c9b0.jpg',
    imageAlt:
      'A rescued cow resting her head beside a small sheep in a hazy meadow at golden hour',
  },
]
